var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextLineSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 2.25C6.39137 2.25 2.25 6.39137 2.25 11.5C2.25 16.6086 6.39137 20.75 11.5 20.75C13.2978 20.75 14.5081 20.3422 15.1668 20.0319C15.3396 19.9505 15.4783 19.95 15.5562 19.976L18.8656 21.0791C20.2336 21.5351 21.5352 20.2336 21.0791 18.8655L19.9697 15.5372C19.9449 15.4628 19.9446 15.3347 20.0176 15.1776C20.3243 14.5184 20.75 13.2807 20.75 11.5C20.75 6.39137 16.6086 2.25 11.5 2.25ZM8 8.75C7.58579 8.75 7.25 9.08579 7.25 9.5C7.25 9.91421 7.58579 10.25 8 10.25H15C15.4142 10.25 15.75 9.91421 15.75 9.5C15.75 9.08579 15.4142 8.75 15 8.75H8ZM8 12.75C7.58579 12.75 7.25 13.0858 7.25 13.5C7.25 13.9142 7.58579 14.25 8 14.25H13C13.4142 14.25 13.75 13.9142 13.75 13.5C13.75 13.0858 13.4142 12.75 13 12.75H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextLineSolid);
export default __webpack_public_path__ + "static/media/text-line-solid.58ce057110089b515a7e771c1432377c.svg";
export { ForwardRef as ReactComponent };